/**
 * Miscellaneous UI-related redux state.
 *
 * Sometimes used for general actions and state
 * when setting up prop inheritance is cumbersome.
 */

import { createSlice } from "@reduxjs/toolkit"
import type { RootState } from "../store"

export const tabsSlice = createSlice({
	name: "tabs",
	initialState: {
		coachTestChartTab: "",
		playerTestChartTab: "",
	},
	reducers: {
		setPlayerTestChartTab(state, { payload }) {
			state.playerTestChartTab = payload
		},
	},
})

export const { setPlayerTestChartTab } = tabsSlice.actions

export const tabsSelector = (state: RootState) => state.tabs
